WiseMetering.Collection.ZoneAttributes = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.ZoneAttribute,
    url: '/zone_attributes',

    requestedPower: function() {
        return this.findWhere({ name: 'Potência Contratada' });
    }
});
